var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3166 3.84994L14.1833 3.84994C15.5083 3.84994 16.0416 4.34993 16.0416 5.6166L16.0416 15.5166L11.4583 15.5166L11.4583 5.6166C11.4583 4.34993 11.9916 3.84994 13.3166 3.84994Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23333 8.0166L7.1 8.0166C8.425 8.0166 8.95833 8.52493 8.95833 9.78327L8.95833 15.5166L4.375 15.5166L4.375 9.78327C4.375 8.52493 4.90833 8.0166 6.23333 8.0166Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 15.5164C18.3334 15.8581 18.0501 16.1414 17.7084 16.1414L2.29175 16.1414C1.94175 16.1498 1.66675 15.8664 1.66675 15.5164C1.66675 15.1664 1.95008 14.8914 2.29175 14.8914L17.7084 14.8914C18.0501 14.8998 18.3334 15.1748 18.3334 15.5164Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.3f3291f60e76a4dbbf7e137049fe9901.svg";
export { ForwardRef as ReactComponent };